export default function reducer(state = {
    voluntary: null,
    essential: null,
    daily: null,
    questionUpdated: null,
    score: null
}, action) {
    switch (action.type) {
        case "STORE_VOLUNTARY_QUESTIONS": {
            return { ...state, voluntary: action.data }
        }
        case "STORE_ESSENTIAL_QUESTIONS": {
            return { ...state, essential: action.data }
        }
        case "STORE_DAILY_QUESTIONS": {
            return { ...state, daily: action.data }
        }
        case "ESSENTIAL_QUESTION_UPDATED": {
            return { ...state, questionUpdated: action.data }
        }
        case "STORE_TEST_SCORE_LIST": {
            return { ...state, score: action.data }
        }
        default:
            break;
    }
    return state;
}
